// estados.json
const Plataformas = {
  plataformas: ["android", "ios"],
};

module.exports = Plataformas;
